import { useQuery } from "@tanstack/react-query";

import { get } from "api";

export const useUser = () => {
  const { data } = useQuery({
    queryKey: ["/user"],
    queryFn: () => get("/user"),
    staleTime: 1000 * 60 * 2,
  });

  return { user: data };
};

export const useUserPreferences = () => {
  const { data } = useQuery({
    queryKey: ["/user/preferences"],
    queryFn: () => get("/user/preferences"),
    staleTime: 1000 * 60 * 2,
  });

  return { preferences: data };
};
